jQuery(document).ready(function ($) {




    $(".featureImg:nth-child(odd)").addClass("featureImg-alt");






    $('.mh-item').matchHeight();


    $('.navMain').dropit();


    $('.card').matchHeight();
    $('.card__heading').matchHeight();
    $('.card__top').matchHeight({
        byRow: false
    });
    $('.card__bottom p').matchHeight();

    /*$('.card__bottom').matchHeight();


    $('.feature-block__item').matchHeight();*/




    $('.contentBlock__item').matchHeight();
    $('.indexCard__bottom').matchHeight();
    $('.fullWidth__item').matchHeight();


    $('.banner__caption__item').matchHeight();


//SMOOTH SCROLLING
    $(".pageDown").on('click', function(event) {

        // Make sure this.hash has a value before overriding default behavior
        if (this.hash !== "") {
            // Prevent default anchor click behavior
            event.preventDefault();

            // Store hash
            var hash = this.hash;

            // Using jQuery's animate() method to add smooth page scroll
            // The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area
            $('html, body').animate({
                scrollTop: $(hash).offset().top
            }, 800, function(){

                // Add hash (#) to URL when done scrolling (default click behavior)
                window.location.hash = hash;
            });
        } // End if
    });


//SMOOTH SCROLLING
    $(".upLink").on('click', function(event) {

        // Make sure this.hash has a value before overriding default behavior
        if (this.hash !== "") {
            // Prevent default anchor click behavior
            event.preventDefault();

            // Store hash
            var hash = this.hash;

            // Using jQuery's animate() method to add smooth page scroll
            // The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area
            $('html, body').animate({
                scrollTop: $(hash).offset().top
            }, 800, function(){

                // Add hash (#) to URL when done scrolling (default click behavior)
                window.location.hash = hash;
            });
        } // End if
    });



    $('.home section').removeClass('section-bg');
    $('.home section:odd').addClass('section-bg');




    $('.blog.related h1, .blog.related .date').wrap("<div class='overflowHidden'></div>" );

    $('.blogBack').parent().addClass('blogBackWrap');

    $('.socialrow').prev().addClass('socialTitle');









    $(window).on("load", function() {
        if ( $( ".noBanner " ).length ) {

            var headerHeight = $('.headerMain-toolBar').height();

            console.log(headerHeight);

            $( "body" ).css('padding-top', headerHeight);

        }
    });



/*var callCount = $('.calloutContainer').children().size();

if(callCount < 2){
    $('.headerMain__item-logo').removeClass('nb-3').addClass('nb-3');
    $('.navContainer').removeClass('nb-7').addClass('nb-9');
    $('.calloutContainer').removeClass('nb-2');

}*/




   /* if ($(".intro-color")[0]){

        var headHeight = $('.headerMain-toolBar').height();
        var padTopVal = $(".intro-color").css('padding-bottom');
       $(".intro-color").css('padding-top', parseFloat(headHeight) + parseFloat(padTopVal));


        $( window ).resize(function() {
            var headHeight = $('.headerMain-toolBar').height();
            var padTopVal = $(".intro-color").css('padding-bottom');
            $(".intro-color").css('padding-top', parseFloat(headHeight) + parseFloat(padTopVal));
        });


    }*/



    var $container = $('.blog .indexCardGrid');


    $container.imagesLoaded( function() {
        $container.masonry({
            // options
            itemSelector: '.indexCardGrid-item',
            percentPosition: true
        });
    });



    $('body').on('click', '.js-searchTrigger', function(e) {
        e.preventDefault();
        $('.js-searchInput').focus();
        $('body').toggleClass('search-open');
    });


    $('body').on('click', '.js-searchClose', function(e) {
        e.preventDefault();
        $('body').removeClass('search-open');
    });




    $('.call-out').before('<li class="navMain__search"><a class="js-searchTrigger" href="#"><i class="fa fa-search" aria-hidden="true"></i></a></li>');




    /*var hash = document.URL.substr(document.URL.indexOf('#')+1);

    console.log(hash);*/


    $(window).on("load", function() {
        if ( $( ".single-pathways " ).length ) {

            $('.single-pathways').fadeIn().addClass('single-pathways-loaded');

        }
    });





});


